
import { createAction } from '@reduxjs/toolkit';
import { AccountActionTypes, LoginRequest, LoginResponse } from './models';

// Use createAction helper functions since they are stictly typed out of the box
export const accountLoginStart = createAction(
  AccountActionTypes.ACCOUNT_LOGIN_START,
  (payload: LoginRequest) => ({payload})
);

export const accountLoginSuccess = createAction(
  AccountActionTypes.ACCOUNT_LOGIN_SUCCESS,
  (payload: LoginResponse) => ({payload})
);

export const accountLoginFailure = createAction(
  AccountActionTypes.ACCOUNT_LOGIN_FAILURE,
  (payload: unknown) => ({payload}));

export const accountLoginCheckStart = createAction(
  AccountActionTypes.ACCOUNT_LOGIN_CHECK_START
);

export const accountLoginCheckSuccess = createAction(
  AccountActionTypes.ACCOUNT_LOGIN_CHECK_SUCCESS,
  (payload: LoginResponse) => ({payload})
);

export const accountLoginCheckFailure = createAction(
  AccountActionTypes.ACCOUNT_LOGIN_CHECK_FAILURE,
  (payload: unknown) => ({payload})
);

export const accountLogoutStart = createAction(
  AccountActionTypes.ACCOUNT_LOGOUT_START,
);

export const accountLogoutSuccess = createAction(
  AccountActionTypes.ACCOUNT_LOGOUT_SUCCESS,
  (payload: boolean) => ({payload})
);

export const accountLogoutFailure = createAction(
  AccountActionTypes.ACCOUNT_LOGOUT_FAILURE,
  (payload: unknown) => ({payload}));

export const accountLogoutSilentlyStart = createAction(
  AccountActionTypes.ACCOUNT_LOGOUT_SILENTLY_START,
);

export const accountLogoutSilentlySuccess = createAction(
  AccountActionTypes.ACCOUNT_LOGOUT_SILENTLY_SUCCESS,
);

export const accountLogoutSilentlyFailure = createAction(
  AccountActionTypes.ACCOUNT_LOGOUT_SILENTLY_FAILURE,
  (payload: unknown) => ({payload}));